const { createContext } = require('react')

export const SectionContext = createContext()
